import { render, staticRenderFns } from "./case-all-export.vue?vue&type=template&id=4a5e4c3f&scoped=true"
import script from "./case-all-export.vue?vue&type=script&lang=ts"
export * from "./case-all-export.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a5e4c3f",
  null
  
)

export default component.exports